import styled from "styled-components";

export const StyledTitle = styled.h4`
  margin: 0 0 2rem 0;
  color: #ddd;
  font-family: Pixel, monospace, "Courier New", Courier;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #000;
  padding: 1.5rem 1.25rem;
  border: 4px solid #333;
  border-radius: 1.25rem;
  margin-bottom: 1rem;
`;
